import { isChestShelf } from "../domain/catalogImport";
import type { ProductFamily } from "../domain/productWorkflow";
import type { WardrobeModule } from "../types";
import { usePlannerStore } from "./usePlannerStore";

/** Модель витрины: стеллаж приходит одной деталью, шкаф — составом корпусов. */
export type CatalogModelDetail = {
  id: string; name: string; description: string; category: string;
  width: number; height: number; depth: number; coverUrl: string;
} & ({ module: WardrobeModule; modules?: undefined } | { modules: WardrobeModule[]; module?: undefined });

/**
 * Поставить модель витрины основой проекта и вернуть её раздел. Комод из
 * витрины открывается в разделе «Комоды», если это чистый комод (один ряд, все
 * ячейки — ящики); низкие модели — как стеллаж.
 */
export function applyCatalogModel(model: CatalogModelDetail): ProductFamily {
  const store = usePlannerStore.getState();
  if (model.modules) {
    store.replaceWithCatalogComposition(model.modules);
    return "wardrobe";
  }
  const chest = isChestShelf(model.module, model.category);
  store.replaceWithCatalogShelf(chest ? { ...model.module, shelvingKind: "chest" } : model.module);
  return chest ? "chest" : "shelving";
}
